module.exports = __webpack_public_path__ + "img/model1.be4bd8ab.png";